<script>

import LoginModal from "@/components/login-modal";
import axios from "axios";
import config from "@/config.json";
import {post} from "@/assets/js/utils";

export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    pricingData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      selected: 0,
      type: 0
    };
  },
  methods: {
    async onBuy(skuId, type) {
      this.selected = skuId;
      this.type = type;
      console.log(`buy ${skuId}`);
      try {
        const data = await post(`${config.api.userinfo}`, {});
        console.log(data);
        if (data && data.errno === 0) {
          await this.createOrder();
        } else {
          this.$bvModal.show("login-modal");
        }
      } catch (e) {
        console.error(e.toString());
      }
    },
    async createOrder() {
      try {
        const data = await post(`${config.api.neworder}`, {sku_id: this.selected, type: this.type});
        if (data.errno === 0) {
          const order_id = data.data.order_id;
          await this.$router.push('/shop-cart?order_id=' + order_id);
        } else {
          // TODO
          // 需要出错误提示浮层
        }
      } catch (e) {}
    }
  },
  components: {
    LoginModal
  }
};
</script>

<template>
  <div>
    <login-modal @onLoginSuccess="createOrder"/>

    <div class="row" v-if="type === 1">
      <div class="col-md-3 col-12 mt-4 pt-2" v-for="(item, index) of pricingData" :key="index" >
        <div class="card pricing-rates business-rate shadow bg-light rounded text-center border-0" >
          <div class="ribbon ribbon-right ribbon-warning overflow-hidden" v-if="item.isBest === true" >
            <span class="text-center d-block shadow small h6">Best</span>
          </div>

          <div class="card-body py-5">
            <h6 class="title font-weight-bold text-uppercase text-primary mb-4">
              {{ item.title }}
            </h6>
            <div class="d-flex justify-content-center mb-4">
              <span class="h4 mb-0 mt-2">{{item.currency}}</span>
              <span class="price h1 mb-0">{{ item.price }}</span>
              <span class="h4 align-self-end mb-1">{{item.period}}</span>
            </div>

            <ul class="list-unstyled mb-0 pl-0">
              <li class="text-muted mb-0" v-for="(feature, index) in item.feature" :key="index" >
                <span class="text-primary mr-2"><i class="uil uil-check-circle align-middle"></i></span >
                {{ feature }}
              </li>
            </ul>
            <a href="#" @click.prevent="onBuy(item.sku_id, item.type)" class="btn btn-primary mt-4">{{ item.button }}</a>
          </div>
        </div>
      </div>

    </div>

    <div class="row align-items-center mt-5" v-if="type === 2">
      <div class="col-lg-5 col-md-6">
        <img width="700" height="881" loading="lazy" src="/images/hosting/1.png" class="img-fluid" :alt="$t('alt.pricing')" />
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title ml-lg-5">
          <h2 class="h4 title mb-4"> {{$t('index.price.enterprise.title')}} </h2>
          <p> {{$t('index.price.enterprise.description')}} </p>
          <p> {{$t('index.price.enterprise.price')}} </p>
          <ul class="list-unstyled text-muted">
            <li class="mb-0" v-for="item in $t('index.price.enterprise.feature')">
                  <span class="text-primary h5 mr-2"
                  ><i class="uil uil-check-circle align-middle"></i></span>
              {{item}}
            </li>
          </ul>
          <a href="#" @click.prevent="onBuy(21, 0)" class="btn btn-primary mt-3">{{$t('index.price.enterprise.button')}} <i class="mdi mdi-chevron-right"></i
          ></a>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
</template>
